import React, {useState} from "react";
import {
    IonItem,
    IonLabel,
    IonSelect,
    IonSelectOption,
    useIonAlert
} from "@ionic/react";
import {useMutation, useQuery} from "@apollo/client";
import {
    USER_GET_ROLES_QUERY,
    USER_MANAGER_UPDATE_USER_ADD_ROLE,
    USER_MANAGER_UPDATE_USER_REMOVE_ROLE
} from "../../schemas/userManager";



const UserManagerEditUserRoles: React.FC<any> = ({user, refetch}:any) => {
    const [presentAlert, dismissAlert] = useIonAlert();
    const [addRoleVal, setAddRoleVal] = useState<number | undefined>(undefined);
    const {loading:rolesLoading, error:rolesError, data: rolesData} = useQuery(USER_GET_ROLES_QUERY, {variables: {}});
    const [addRoleMutation] = useMutation(USER_MANAGER_UPDATE_USER_ADD_ROLE);
    const [removeRoleMutation] = useMutation(USER_MANAGER_UPDATE_USER_REMOVE_ROLE);

    const addRole = async (roleId: number)=> {
        if (roleId) {
            const result = await addRoleMutation({variables: {data: {roleId: roleId, userId: user.id}}});
            await refetch();
        }
    };

    const removeRole = async (roleId: number) => {
        if (window.confirm("Are you sure you want to remove this role from this user?")) {
            const result = await removeRoleMutation({variables: {data: {roleId: roleId, userId: user.id}}});
            await refetch();
        }
    };

    return (
        <div className="ion-padding panel" slot="content">


            {user && user.user_roles && user.user_roles.length > 0 && user.user_roles.map((role: any) => {
                return (
                    <div key={role.roles.id} className="badge" style={{
                        float: 'left',
                        backgroundColor: '#3880ff',
                        display: 'inline-block',
                        margin: '5px',
                        padding: '5px 10px 5px 10px'
                    }}>
                        {role.roles.name}
                        <button style={{
                            marginLeft: '5px',
                            backgroundColor: 'transparent'
                        }} onClick={() => removeRole(role.roles.id)}>X
                        </button>
                    </div>
                )
            })}
            <div style={{clear: 'both'}}></div>

            <div>

                <p>Add role to user:</p>
                <IonSelect label="Role" labelPlacement="start" value={addRoleVal} onIonChange={(e) => addRole(e.detail.value)}>
                    {rolesData && rolesData.getRoles.map((role: any) => {
                        let found = false;
                        user.user_roles.forEach((role2: any) => {
                            if (role.id === role2.roles.id) {
                                found = true;
                            }
                        })
                        if (!found) {
                            return (
                                <IonSelectOption key={"role_" + role.id} value={role.id}>{role.name}</IonSelectOption>
                            );
                        }
                    })}
                </IonSelect>

            </div>
        </div>
    )

};

export default UserManagerEditUserRoles;